import React from 'react';
import { useLocation } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import ConsentModal from './ConsentModal';

// Routes that have their own in-flow acknowledgement and must NOT be
// interrupted by the global charter modal.  /quiz uses an AcknowledgeScreen
// inside the assessment flow; popping a second modal on top of it derails
// the post-registration → Academic transition.
const SKIP_ROUTES = ['/quiz'];

export default function GlobalDisclaimer() {
    const { userData, acknowledgeDisclaimer, isLoading } = useUser();
    const location = useLocation();

    // Visibility Logic: Show ONCE per user account, never reappear
    // (Compliance: Charter terms baked at signup. Re-prompt only if Eager updates Charter.)
    const shouldShow = () => {
        if (isLoading || !userData) return false;

        // Skip on routes with their own acknowledgement
        if (SKIP_ROUTES.includes(location.pathname)) return false;

        // Hide for Admin/Partner/Recruiter roles
        const skipRoles = ['admin', 'partner', 'recruiter'];
        if (skipRoles.includes(userData.role)) return false;

        // Show only if NEVER acknowledged
        return !userData.lastAcknowledgedAt;
    };

    if (!shouldShow()) {
        return null;
    }

    return <ConsentModal onAccept={acknowledgeDisclaimer} />;
}
